import AV from 'leancloud-storage'
import { User } from '../models'
import store from '../store/index.js'

export const Post = AV.Object.extend('Post')
export const PostComment = AV.Object.extend('PostComment')
export const LikePost = AV.Object.extend('LikePost')

/**
 * 通过 ID 获取 Post
 */
Post.getById = function (id) {
  return AV.Cloud.rpc('getPostById', { postId: id }).then((post) => {
    return post.toJSON()
  })
}

/**
 * 获取帖子评论
 */
Post.getComments = function (id, page = 1, perPage = 15) {
  return AV.Cloud.rpc('getPostCommentsByTimeDesc', { postId: id, page, perPage }).then((comments) => {
    return comments.map(comment => comment.toJSON())
  })
}

// 检查是否已喜欢
Post.checkLiked = function (id) {
  if (!store.state.user.user) {
    return Promise.resolve(false)
  }

  return AV.Cloud.run('checkLikePost', { postId: id })
}

// 喜欢
Post.like = function (id) {
  if (!store.state.user.user) {
    return Promise.reject()
  }

  return AV.Cloud.run('likePost', { postId: id }).then(function (data) {
    return data.succeeded
  }, function (err) {
    return false
  })
}

// 不喜欢
Post.unlike = function (id) {
  if (!store.state.user.user) {
    return Promise.reject()
  }

  return AV.Cloud.run('unlikePost', { postId: id }).then(function (data) {
    return data.succeeded
  }, function (err) {
    return false
  })
}

// 评论
Post.comment = function (id, content, targetComment) {
  if (!store.state.user.user) {
    return Promise.reject()
  }

  let comment = new PostComment()

  comment.set('user', AV.Object.createWithoutData('_User', store.state.user.user.objectId))
  comment.set('post', AV.Object.createWithoutData('Post', id))
  comment.set('content', content)
  if (targetComment) {
    comment.set('targetComment', AV.Object.createWithoutData('PostComment', targetComment.objectId))
    comment.set('targetUser', AV.Object.createWithoutData('_User', targetComment.user.objectId))
  }
  return comment.save().then((comment) => {
    return comment.fetch({ include: 'user,targetComment,targetUser' })
  }).then((comment) => {
    return comment.toJSON()
  })
}

// 删除评论
PostComment.delete = function (objectId) {
  let comment = AV.Object.createWithoutData('PostComment', objectId)

  return comment.destroy()
}

// 可以根据频道选择创作, channelId如果缺省为获得全部作品
// Post.getWorkPosts = function ({workId, channelId, page = 1, perPage = 10}) {
//   return AV.Cloud.rpc('getWorkPosts', {
//     workId,
//     channelId,
//     page,
//     perPage
//   }).then(posts => posts.map(post => post.toJSON()))
// }

// 更换api 获得精品优先的帖子
Post.getWorkPosts = function ({ workId, channelId, page = 1, perPage = 10 }) {
  return AV.Cloud.rpc('getSortWorkPosts', {
    workId,
    channelId,
    page,
    perPage
  }).then(posts => posts.map(post => post.toJSON()))
}

// 获得作者下的创作  (精品优先)
Post.getAuthorPosts = function ({ authorId, channelId, page = 1, perPage = 10 }) {
  return AV.Cloud.rpc('getSortAuthorPosts', {
    authorId,
    channelId,
    page,
    perPage
  }).then(posts => posts.map(post => post.toJSON()))
}

// 获得分类下的创作  (精品优先)
Post.getCollectionPosts = function ({ collectionId, channelId, page = 1, perPage = 10 }) {
  return AV.Cloud.rpc('getSortCollectionPosts', {
    collectionId,
    channelId,
    page,
    perPage
  }).then(posts => posts.map(post => post.toJSON()))
}

Post.getCountByWorkId = function (workId) {
  return AV.Cloud.rpc('getPostCountByWorkId', {
    workId
  })
}

Post.getUserPosts = function ({ userId, channelId, page = 1, perPage = 15 }) {
  return AV.Cloud.rpc('getUserPosts', {
    userId,
    page,
    channelId,
    perPage
  }).then(posts => posts.map(post => post.toJSON()))
}

Post.getUserLikedPosts = function ({ userId, page = 1, perPage = 15 }) {
  return AV.Cloud.rpc('getUserLikedPosts', {
    userId,
    page,
    perPage
  }).then(posts => posts.map(post => post.toJSON()))
}

Post.getUserChannelCount = function (userId) {
  return AV.Cloud.rpc('getUserKindPostLikeList', {
    userId
  })
}

Post.getMiniUserById = function (userId) {
  return AV.Cloud.rpc('getMiniUserById', {
    userId
  })
}


Post.getPublicLists = function (userId) {
  return AV.Cloud.rpc('getPublicLists', {
    userId
  })
}



// WEBPACK FOOTER //
// ./src/models/post.js